<template>
  <div class="PuntosDetalle">
    <h1>Información del punto</h1>
  </div>
</template>

<script>
  import sha1 from 'js-sha1'
  import md5 from 'blueimp-md5'
  import Snackbar from 'node-snackbar'
  export default {
    name: 'PuntosDetalle',
    beforeCreate(){
      if (!this.$session.exists()) {
        this.$router.push('/login')
      }
    },
    data(){
      return {
        msg: 'Inicio'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PuntosDetalle.vue?770c21a3